import { FC, useEffect } from 'react';
import { useToast } from '@/contexts/ToastContext';

/**
 * Mostra toast quando o backend devolve 403 `dashboard_feature_not_enabled`.
 *
 * O `DashboardRoute` cobre a navegação; este host cobre o admin desligando a flag
 * com o painel aberto — sem ele, o próximo "Atualizar" simplesmente falharia calado.
 * Fica montado uma vez no `AppLayout`.
 */
const DashboardFeatureBlockedHost: FC = () => {
  const { showToast } = useToast();

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<{ message?: string }>).detail;
      showToast(
        detail?.message || 'Seu acesso aos painéis foi desligado. Fale com seu admin.',
        'warning',
      );
    };
    window.addEventListener('dashboard-feature-blocked', handler);
    return () => window.removeEventListener('dashboard-feature-blocked', handler);
  }, [showToast]);

  return null;
};

export default DashboardFeatureBlockedHost;
